import { Container } from '@mantine/core';
export const containerProps = Container.extend({
    defaultProps: {
        maw: 1200,
    },
});
